import { render, staticRenderFns } from "./car_Violation.vue?vue&type=template&id=a61bdf8a&scoped=true"
import script from "./car_Violation.vue?vue&type=script&lang=js"
export * from "./car_Violation.vue?vue&type=script&lang=js"
import style0 from "./car_Violation.vue?vue&type=style&index=0&id=a61bdf8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61bdf8a",
  null
  
)

export default component.exports